import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { logout } from '@starterapp/shared-services/authentication/authentication';
import useTransaction from '@starterapp/shared-services/transaction/useTransaction';

const Logout = () => {
    const history = useHistory();
    const { deleteTransaction } = useTransaction();

    useEffect(() => {
        (async () => {
            await deleteTransaction(); // Uncomment this line if you also want to delete an outstanding transaction
            localStorage.clear();
            sessionStorage.clear();
            await logout();
            history.push('/');
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            Logging out
        </>
    );
};

export default Logout;
